import React, { createContext, useContext } from 'react';

interface NavigationContextType {
  currentRoute: string;
  setCurrentRoute: (route: string) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider = NavigationContext.Provider;

export const useNavigationContext = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    // Return a no-op function for mobile platforms where context isn't provided
    return {
      currentRoute: '',
      setCurrentRoute: () => {},
    };
  }
  return context;
};
